import { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Tooltip } from '@mui/material';

const BreadcrumbBackButton = ({ label, onClick }) => {
	const textRef = useRef(null);
	const [isTruncated, setIsTruncated] = useState(false);

	// Track whether the breadcrumb label is visually truncated so the tooltip
	// is shown only when the full label cannot be displayed
	useEffect(() => {
		const element = textRef.current;

		if (!element) return undefined;

		const checkTruncation = () => {
			setIsTruncated(element.scrollWidth > element.clientWidth);
		};

		checkTruncation();

		const resizeObserver = new ResizeObserver(checkTruncation);
		resizeObserver.observe(element);

		return () => resizeObserver.disconnect();
	}, [label]);

	const button = (
		<Button
			type='button'
			variant='text'
			size='small'
			onClick={onClick}
			sx={{
				minWidth: 0,
				maxWidth: '65%',
				p: 0,
				color: 'text.secondary',
				fontSize: '12px',
				fontWeight: 500,
				justifyContent: 'flex-start',
				overflow: 'hidden',
				'&:hover': {
					backgroundColor: 'transparent',
					color: 'text.primary',
				},
			}}
		>
			<Box
				ref={textRef}
				component='span'
				sx={{
					display: 'block',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
					whiteSpace: 'nowrap',
				}}
			>
				‹ {label}
			</Box>
		</Button>
	);

	return isTruncated ? (
		<Tooltip title={label} placement='top' arrow>
			{button}
		</Tooltip>
	) : (
		button
	);
};

BreadcrumbBackButton.propTypes = {
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
};

export default BreadcrumbBackButton;
